module.exports = __webpack_public_path__ + "a9979cc7f755861f15cdb6b42db014d2.jpg";